export const WEB_URL = process.env.WEB_URL;
export const STATIC_ADDRESS = process.env.STATIC_ADDRESS;
export const SERVER_TYPE = process.env.SERVER_TYPE;
export const SERVER_ENV = process.env.SERVER_ENV;
export const GTM_ID = process.env.GTM_ID;
export const OPTIMIZE_ID = process.env.OPTIMIZE_ID;
export const ONE_ID_URL = process.env.ONE_ID_URL;
export const ONE_ID_CLIENT_ID = process.env.ONE_ID_CLIENT_ID;
export const DEFAULT_DOCUMENT_TITLE = '크레딧잡 - 전국 42만 기업, 연봉정보 KREDIT JOB';
